import axios from 'axios';
import apiConfig from '../../api.config';

var CancelToken = axios.CancelToken;
var cancel;

export default function getBookingReportDetail(data) {
  const {
    host,
    URIs: { bookingReportDetail },
  } = apiConfig;

  const uri = `${host}${bookingReportDetail}?filter=${JSON.stringify(data)}`;

  if (cancel) cancel();

  return axios
    .get(uri, {
      headers: {
        'Content-Type': 'application/json',
      },
      cancelToken: new CancelToken(function executor(c) {
        // An executor function receives a cancel function as a parameter
        cancel = c;
      }),
    })
    .then(res => {
      return res.data;
    });
}
